<script>
  export let name;
</script>

<div class="container">{name}'s Homework</div>

<style>
  .container {
    background: white;
    width: 100%;
    margin-top: auto;
    font-size: 20px;
    color: #b4bbbf;
    text-align: center;
    padding: 60px;
    font-weight: 500;
  }
</style>
